import { NavLink } from 'react-router-dom';
import { 
  House, 
  ArrowsLeftRight, 
  ChartPie, 
  Target, 
  Sparkle,
  ShoppingCart,
  Gear
} from '@phosphor-icons/react';

const navItems = [
  { to: '/dashboard', icon: House, label: 'Home' },
  { to: '/transactions', icon: ArrowsLeftRight, label: 'Transactions' },
  { to: '/budget', icon: ChartPie, label: 'Budget' },
  { to: '/goals', icon: Target, label: 'Goals' },
  { to: '/insights', icon: Sparkle, label: 'AI' },
];

export function BottomNav() {
  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 bg-[#0B0F1A]/90 backdrop-blur-xl border-t border-white/5 pb-safe pt-2 px-2 z-50 md:hidden"
      data-testid="bottom-nav"
    >
      <div className="flex justify-around items-center max-w-md mx-auto">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center py-2 px-3 rounded-xl transition-all ${
                isActive 
                  ? 'text-[#3B82F6]' 
                  : 'text-[#9CA3AF] hover:text-[#F9FAFB]'
              }`
            }
            data-testid={`nav-${label.toLowerCase()}`}
          >
            {({ isActive }) => (
              <>
                <Icon 
                  size={24} 
                  weight={isActive ? 'duotone' : 'regular'} 
                />
                <span className="text-xs mt-1 font-medium">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export function Sidebar() {
  const allNavItems = [
    ...navItems,
    { to: '/affordability', icon: ShoppingCart, label: 'Afford?' },
    { to: '/settings', icon: Gear, label: 'Settings' },
  ];

  return (
    <aside 
      className="hidden md:flex flex-col w-64 fixed top-0 bottom-0 left-0 bg-[#0B0F1A] border-r border-white/5 p-6 z-50"
      data-testid="sidebar"
    >
      <div className="mb-10 flex items-center gap-3">
        <img src="/logo-sidebar.png" alt="UniWallet" className="w-9 h-9 rounded-lg" />
        <div>
          <h1 className="text-xl font-semibold tracking-tight">
            <span className="gradient-text">Uni</span>Wallet
          </h1>
          <p className="text-xs text-[#9CA3AF]">Student Finance Assistant</p>
        </div>
      </div>
      
      <nav className="flex-1 space-y-1">
        {allNavItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 rounded-xl transition-all ${
                isActive 
                  ? 'bg-[#3B82F6]/10 text-[#3B82F6] border border-[#3B82F6]/20' 
                  : 'text-[#9CA3AF] hover:text-[#F9FAFB] hover:bg-white/5'
              }`
            }
            data-testid={`sidebar-${label.toLowerCase()}`}
          >
            {({ isActive }) => (
              <>
                <Icon 
                  size={20} 
                  weight={isActive ? 'duotone' : 'regular'} 
                />
                <span className="font-medium">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="mt-auto pt-6 border-t border-white/5">
        <div className="card-secondary p-4">
          <p className="text-xs text-[#9CA3AF]">Powered by AI</p>
          <p className="text-sm font-medium mt-1 gradient-text">Smart insights for students</p>
        </div>
      </div>
    </aside>
  );
}
